import React from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Divider } from "../../../Divider";
import { Title3, Body } from "../../../Text";
import Remixing from "../../../../../animations/remixing.json";
import Lottie from "lottie-react";
import { EClipsViews } from "../../../../@types";

interface IProcessingProps {
  processingData?: { montages: number; userFeed: number };
  view: EClipsViews;
}

const SUPPORTED_VIEWS = [EClipsViews.Montages, EClipsViews.Clips];

const lottieStyle = {
  width: 150,
};

export function Processing({ processingData, view }: IProcessingProps) {
  const VIEW_UNSUPPORTED = !SUPPORTED_VIEWS.includes(view);

  if (view === EClipsViews.Clips && !processingData?.userFeed) {
    return <></>;
  }
  if (view === EClipsViews.Montages && !processingData?.montages) {
    return <></>;
  }
  if (!processingData?.montages && !processingData?.userFeed) return <></>;
  if (VIEW_UNSUPPORTED) return <></>;

  const CONTENT_MAP: any = {
    [EClipsViews.Clips]: {
      title: "Your clips are processing.",
      body: (
        <>
          Leave this page open and we will refresh it for you once your clips
          are ready!
        </>
      ),
    },
    [EClipsViews.Montages]: {
      title: "Your montage is processing.",
      body: (
        <>
          Leave this page open and we will refresh it for you once your montage
          is ready!
        </>
      ),
    },
  };

  return (
    <>
      <Box variant={"card"}>
        <Card>
          <StyledFlex
            alignItems={"center"}
            justifyContent={"center"}
            flexDirection={"column"}
          >
            <Lottie animationData={Remixing} style={lottieStyle} loop={true} />
            <Title3 mb={3}>{CONTENT_MAP[view].title}</Title3>
            <Body color="chalk" textAlign={"center"} mb={3}>
              {CONTENT_MAP[view].body}
            </Body>
          </StyledFlex>
        </Card>
      </Box>
      <Divider>
        <Flex alignItems={"center"}>
          Hang tight {"  "}
          {/* <ProcessingClips px={3} py={2} m={2} backgroundColor="darkerNed">
            {count}
          </ProcessingClips> */}
          {/* Clips */}
        </Flex>
      </Divider>
    </>
  );
}

const Card = styled(Flex)`
  display: block;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 9px;
  padding-top: 50%;
  border-width: 2px;
  border-style: dashed;
  border-color: #253a49;
  background-image: linear-gradient(
    to left bottom,
    #212b36,
    #202b36,
    #202b37,
    #1f2b37,
    #1e2b37
  );
`;

const StyledFlex = styled(Flex)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
